import { ReactElement } from 'react';

import { StyledFlex, TextView } from '@dreryk/react-components';
import { createInterpolatedTranslationKey, dateFormatter, hourMinuteFormatter, Translate } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

const MILLISECONDS_IN_MINUTE = 60_000;

type AppointmentTimeSlotSectionProps = {
   beginDate: Date;
   endDate: Date;
};

export const AppointmentTimeSlotSection = (props: AppointmentTimeSlotSectionProps): ReactElement => {
   const durationInMinutes = Math.round(
      (new Date(props.endDate).getTime() - new Date(props.beginDate).getTime()) / MILLISECONDS_IN_MINUTE
   );

   return (
      <StyledFlex gap={'20px'}>
         <TextView testId={'appointmentDate'} label={translationKeys.date}>
            {dateFormatter(props.beginDate)}
         </TextView>
         <TextView testId={'appointmentStartTime'} label={translationKeys.startTime}>
            {hourMinuteFormatter(props.beginDate)}
         </TextView>
         <TextView testId={'appointmentEndTime'} label={translationKeys.endTime}>
            {hourMinuteFormatter(props.endDate)}
         </TextView>
         <TextView testId={'appointmentDuration'} label={translationKeys.duration}>
            <Translate>
               {createInterpolatedTranslationKey(translationKeys.durationInMinutes, { minutes: durationInMinutes })}
            </Translate>
         </TextView>
      </StyledFlex>
   );
};
